export default interface Phone {
  Code: string;
  Number: string;
  Home?: string;
  Work?: string;
}

export type PhoneFieldType = keyof Phone;

export const names: { [key in PhoneFieldType]: string } = {
  Code: 'Code',
  Number: 'Number',
  Home: 'Home',
  Work: 'Work',
};
